/** Convert an iterable into an array, if necessary */
export function asArray<T>(obj: Iterable<T>): readonly T[] {
    return Array.isArray(obj) ? (obj as T[]) : [...obj];
}
